"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@productlane/lib/src/browser"

export const Label = React.memo(
	React.forwardRef<
		React.ElementRef<typeof LabelPrimitive.Root>,
		React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
	>(({ className, ...props }, ref) => (
		<LabelPrimitive.Root
			ref={ref}
			className={cn(
				"text-sm font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
				className,
			)}
			{...props}
		/>
	)),
)
